export default __webpack_public_path__ + "static/media/techblog.8195cc93.png";